import { formatNumber } from '../lib/format';

export function Pagination({
  page,
  pageSize,
  totalCount,
  totalPages,
  onPageChange,
  onPageSizeChange,
}: {
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  onPageSizeChange?: (pageSize: number) => void;
}): JSX.Element {
  const first = totalCount === 0 ? 0 : (page - 1) * pageSize + 1;
  const last = Math.min(page * pageSize, totalCount);
  const lastPage = Math.max(1, totalPages);

  return (
    <nav className="pagination" aria-label="Pagination">
      <p className="pagination-summary">
        {totalCount === 0
          ? 'No records'
          : `${formatNumber(first)}–${formatNumber(last)} of ${formatNumber(totalCount)}`}
      </p>
      <div className="pagination-controls">
        {onPageSizeChange ? (
          <label className="pagination-size">
            <span>Rows</span>
            <select
              className="input select"
              value={pageSize}
              onChange={(event) => onPageSizeChange(Number(event.target.value))}
            >
              {[10, 25, 50, 100].map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
          </label>
        ) : null}
        <button
          type="button"
          className="btn btn-ghost"
          onClick={() => onPageChange(1)}
          disabled={page <= 1}
          aria-label="First page"
        >
          «
        </button>
        <button
          type="button"
          className="btn btn-ghost"
          onClick={() => onPageChange(page - 1)}
          disabled={page <= 1}
          aria-label="Previous page"
        >
          ‹
        </button>
        <span className="pagination-page" aria-live="polite">
          Page {page} of {lastPage}
        </span>
        <button
          type="button"
          className="btn btn-ghost"
          onClick={() => onPageChange(page + 1)}
          disabled={page >= lastPage}
          aria-label="Next page"
        >
          ›
        </button>
        <button
          type="button"
          className="btn btn-ghost"
          onClick={() => onPageChange(lastPage)}
          disabled={page >= lastPage}
          aria-label="Last page"
        >
          »
        </button>
      </div>
    </nav>
  );
}
